<div class="col-12 col-xl-8">
  <div class="entity-binding-workspace bg-white bg-opacity-75 rounded-4 border shadow p-3 h-100">
    <div class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-1">
      <div>
        <p class="fw-bold mb-1 text-x">Active Verification Services</p>
        <div class="entity-panel-caption text-xs fw-semibold">
          Bind verification services to this entity configuration.
        </div>
      </div>
      <span class="entity-detail-pill entity-status-active rounded-pill fw-bold text-uppercase">
        {{ bound_services_count }} Active
      </span>
    </div>

    <div class="entity-new-binding-card bg-white rounded-4 border p-3 mb-3 mt-3 shadow">
      <div class="d-flex align-items-start gap-2 mb-3">
        <div class="entity-new-binding-icon rounded-3 d-inline-flex align-items-center justify-content-center">
          <i class="bi bi-link-45deg"></i>
        </div>
        <div>
          <div class="fw-bold text-xs mb-1">Add Service Binding</div>
          <div class="entity-panel-caption text-xxs fw-semibold">
            Bind a verification service to this entity setup.
          </div>
        </div>
      </div>

      <div class="row g-3 align-items-end">
        <div class="col-12 col-lg-9">
          <label class="form-label mb-1 fw-semibold text-xs">Select Service</label>
          <div ref="serviceMultiselect" class="template-multiselect position-relative">
            <button
              type="button"
              class="form-select subsystem-select entity-binding-control rounded-small d-flex align-items-center justify-content-between gap-2 p-2 shadow-sm"
              :disabled="services_loading || creating_service_binding"
              @click="toggle_service_dropdown"
            >
              <span class="text-truncate">{{ selected_services_label }}</span>
              <i class="bi bi-chevron-down small"></i>
            </button>

            <div v-if="service_dropdown_open" class="template-multiselect-menu rounded-small shadow-sm mt-1 p-2">
              <div v-if="services_loading" class="px-2 py-1 small text-secondary">Loading services...</div>
              <div v-else-if="!bindable_services.length" class="px-2 py-1 small text-secondary">No services available</div>
              <div v-else class="template-multiselect-items">
                <label
                  v-for="service in bindable_services"
                  :key="service.id"
                  class="template-multiselect-item d-flex align-items-center gap-2 px-2 py-1 rounded-small"
                >
                  <input
                    class="form-check-input mt-0"
                    type="checkbox"
                    :value="String(service.id)"
                    v-model="selected_service_ids"
                    :disabled="creating_service_binding"
                  />
                  <span class="small text-truncate">{{ service.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-3">
          <button type="button"
            class="btn entity-create-binding-btn rounded-small shadow-sm px-3 py-2 fw-semibold border-0 text-white w-100"
            :disabled="creating_service_binding || !selected_service_ids.length" @click="add_service_bindings">
            <i class="bi bi-link-45deg me-2"></i>
            {{ creating_service_binding ? 'Binding...' : 'Bind Service(s)' }}
          </button>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-between gap-2 mb-2">
      <div class="fw-bold small">Current Service Bindings</div>
    </div>

    <div class="d-flex flex-column gap-2">
      <div v-for="binding in service_bindings" :key="binding.id"
        class="entity-binding-list-card bg-white d-flex align-items-start justify-content-between gap-3 rounded-4 p-3 shadow-sm">
        <div class="d-flex align-items-start gap-3 flex-grow-1 overflow-hidden">
          <div
            class="entity-summary-icon mt-2 ms-2 rounded-3 d-inline-flex align-items-center justify-content-center flex-shrink-0 align-self-stretch">
            <i class="bi bi-patch-check fs-4"></i>
          </div>
          <div class="flex-grow-1 overflow-hidden">
            <div class="fw-bold small text-truncate mb-1">{{ binding.name || 'Verification Service' }}</div>
            <div v-if="binding.description" class="entity-panel-caption text-xxs text-truncate">
              {{ binding.description }}
            </div>
          </div>
        </div>

        <div class="d-flex flex-column align-items-end gap-2 flex-shrink-0">
          <button
            type="button"
            class="btn btn-link btn-sm p-0 text-danger text-decoration-none small fw-semibold d-inline-flex align-items-center justify-content-end gap-2 text-nowrap"
            :disabled="removing_binding_id === binding.id"
            @click="remove_service_binding(binding)"
          >
            <i class="bi bi-trash3"></i>
            {{ removing_binding_id === binding.id ? 'Removing...' : 'Remove' }}
          </button>
        </div>
      </div>

      <div v-if="!service_bindings.length" class="entity-activity-card rounded-4 p-3 small text-secondary bg-white">
        No verification services bound yet. Add a service above.
      </div>
    </div>

  </div>
</div>

<div class="col-12 col-xl-4">
  <div class="entity-overview-profile-card rounded-4 border shadow p-4 h-100 overflow-hidden">
    <h2 class="entity-overview-title fw-bold mb-3">Verification Context</h2>
    <div class="small mb-4">
      <div class="entity-panel-caption fw-semibold">Viewing services for</div>
      <div class="fw-bold">{{ entityTypeName || 'Entity' }}</div>
    </div>

    <div class="d-flex flex-column gap-3 my-4">
      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="small text-secondary">Available Services</span>
        <span class="small fw-bold">{{ available_services_count }}</span>
      </div>
      <div class="d-flex align-items-center justify-content-between gap-2">
        <span class="small text-secondary">Bound Services</span>
        <span class="small fw-bold">{{ bound_services_count }}</span>
      </div>
    </div>

    <button type="button" class="btn entity-overview-profile-btn rounded-small w-100 text-xs fw-semibold"
      @click="go_to_entity_overview">
      <i class="bi bi-eye me-2"></i>
      View Entity Overview
    </button>
  </div>
</div>
